import React from 'react'
import {useTranslation} from 'react-i18next'
import {Row, Typography} from 'antd'
import Joyride from 'react-joyride'
import {observer} from 'mobx-react'

import {Button, Modal} from '@/components'
import {SKIP_USER_GUIDE, START_TUTORIAL} from '@/constants/playwright-ids'
import {COMPANY_NAME} from '@/constants/app'
import {userGuideStyles} from '@/constants/user-guide/user-guide-styles'

import styles from './styles.scss'

export const UserGuide = observer(
    ({steps, run, handleCallback, stepIndex, isModalVisible, onGotItClick, onSkipPress}) => {
        const {t} = useTranslation()

        return (
            <>
                <Joyride
                    disableOverlay={true}
                    scrollToFirstStep
                    hideCloseButton
                    callback={handleCallback}
                    steps={steps}
                    stepIndex={stepIndex}
                    continuous
                    run={run}
                    showSkipButton
                    disableScrolling
                    locale={{
                        back: t('UserGuide.back'),
                        close: t('UserGuide.close'),
                        last: t('UserGuide.close'),
                        next: t('UserGuide.next'),
                        open: t('UserGuide.open'),
                        skip: t('UserGuide.skip')
                    }}
                    styles={userGuideStyles}
                />
                <Modal
                    open={isModalVisible}
                    className={styles.modal}
                    onCancel={onSkipPress}
                    footer={[
                        <Button onClick={onSkipPress} key={'skip'} data-test-id={SKIP_USER_GUIDE}>
                            {t('UserGuide.skipTutorial')}
                        </Button>,
                        <Button
                            key={'go-next'}
                            type={'primary'}
                            onClick={onGotItClick}
                            data-test-id={START_TUTORIAL}
                        >
                            {t('UserGuide.startTutorial')}
                        </Button>
                    ]}
                >
                    <Row justify={'center'}>
                        <img
                            className={styles.image}
                            src={'/img/guide/welcome.svg'}
                            alt={'Welcome'}
                        />
                    </Row>
                    <br />
                    <Row justify={'center'}>
                        <Typography.Title className={styles.title} level={3}>
                            {t('UserGuide.welcome', {companyName: COMPANY_NAME})}
                        </Typography.Title>
                    </Row>
                    <Row justify={'center'}>
                        <Typography.Title level={3}>
                            {t('UserGuide.merchantPortal')}
                        </Typography.Title>
                    </Row>
                    <Row justify={'center'}>
                        <Typography.Text className={styles.description}>
                            {t('UserGuide.description1')}
                        </Typography.Text>
                    </Row>
                    <br />
                    <Row justify={'center'}>
                        <Typography.Text className={styles.description}>
                            {t('UserGuide.description2')}
                        </Typography.Text>
                    </Row>
                </Modal>
            </>
        )
    }
)
